<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { RowInfo } from '@shared/ui/other'

import { useMainInfoEmail } from '../../model/use-main-info-email.hook'

defineOptions({
  name: 'MainInfoEmail',
})

const { refValue } = useMainInfoEmail()
</script>

<template>
  <RowInfo
    title="Email"
    :value="refValue"
    is-copy-show
  >
    <AppText name="body1-medium">
      {{ refValue }}
    </AppText>
  </RowInfo>
</template>
